import React, {useContext, useEffect, useState} from "react";
import {TranslateContext} from "../../context/TranslateContext";
import {getLingueApi} from "./services/LingueServices";
import ConfLingueView from "./ConfLingueView";

export default function ConfLingueController() {

    const [loadingData, setLoadingData] = useState(true);

    const [lingue, setLingue] = useState([]);

    const {translate} = useContext(TranslateContext);

    async function getLingue() {
        const response = await getLingueApi();
        setLingue(response.data.data);
        setLoadingData(false);
    }

    useEffect(() => {
        getLingue();
    }, []);

    return (
        !loadingData &&
        <ConfLingueView
            loadingData={loadingData}
            lingue={lingue}
            translate={translate}
        />
    );
}
